import React, { useState, useCallback } from "react";
import config from "../config/config";
import { Route, Link } from "react-router-dom";
import "../css/menu.css";
import { slide as MenuNav } from "react-burger-menu";
import {
	ActionList,
	Badge,
	Button,
	ButtonGroup,
	Link as LinkPolaris,
	Popover,
} from "@shopify/polaris";
import { Link as RoterLink } from "react-router-dom";
import HelpCenter from "./HelpCenter";
import ring from "../assets/ring.gif";
import {
	SettingsMinor,
	OrderStatusMinor,
	DisputeMinor,
	NoteMinor,
	PlayMinor,
	QuestionMarkMinor,
	OnlineStoreMinor,
	ReportMinor,
	FavoriteMajor,
} from "@shopify/polaris-icons";
import { useSelector } from "react-redux";
import WhatNew from "./whatnew/WhatNew";
import SvgWhatNew from "./whatnew/SvgWhatNew";
import AffiliateProgram from "./feature/affiliate";

const menu = [
	{
		to: {
			pathname: config.pathName + "/home",
			search: "?" + config.urlParamsValue,
		},
		label: "Dashboard",
		icon: ReportMinor,
		exact: false,
	},
	{
		to: {
			pathname: config.pathName + "/orders",
			search: "?" + config.urlParamsValue,
		},
		label: "Orders",
		icon: OrderStatusMinor,
		exact: false,
	},
	{
		to: {
			pathname: config.pathName + "/settings",
			search: "?" + config.urlParamsValue,
		},
		label: "Settings",
		icon: SettingsMinor,
		exact: false,
	},
	// {
	//   to: {
	//     pathname: config.pathName + "/dispute",
	//     search: "?" + config.urlParamsValue,
	//   },
	//   label: "Dispute",
	//   icon: DisputeMinor,
	//   exact: false,
	// },
	{
		to: {
			pathname: config.pathName + "/account",
			search: "?" + config.urlParamsValue,
		},
		label: "Account plan",
		icon: OnlineStoreMinor,
		exact: false,
	},
	{
		to: {
			pathname: config.pathName + "/affiliate",
			search: "?" + config.urlParamsValue,
		},
		label: "Affiliate",
		icon: FavoriteMajor,
		exact: false,
	},
];

const Menu = () => {
	const [menuMobileOpen, setMenuMobileOpen] = useState(false);
	const [openFaqs, setOpenFaqs] = useState(false);
	const dataSettings = useSelector((state) => state.dataSettings);
	const showMenu = (menus) => {
		var result = null;
		if (menus.length > 0) {
			result = menus.map((menu, index) => {
				return (
					<MenuLink
						key={index}
						label={menu.label}
						to={menu.to}
						icon={menu.icon}
						activeOnlyWhenExact={menu.exact}
					/>
				);
			});
		}
		return result;
	};

	const MenuLink = ({ label, to, icon, activeOnlyWhenExact }) => {
		if (config.platform == "WOO_COMMERCE") {
			if (
				label == "Dispute" ||
				label == "Video Tutorial" ||
				label == "Integrations"
			) {
				return null;
			} else {
				return (
					<Route
						path={to.pathname}
						exact={activeOnlyWhenExact}
						children={({ match }) => {
							let active = match ? true : false;
							return (
								<Link to={to}>
									<Button icon={icon} primary={active}>
										{label}
									</Button>
								</Link>
							);
						}}
					/>
				);
			}
		} else {
			return (
				<Route
					path={to.pathname}
					exact={activeOnlyWhenExact}
					children={({ match }) => {
						let active = match ? true : false;
						return (
							<Link to={to}>
								<Button icon={icon} primary={active}>
									{label}
								</Button>
							</Link>
						);
					}}
				/>
			);
		}
	};

	const showMenuMobile = (menus) => {
		var result = null;

		if (menus.length > 0) {
			result = menus.map((menu, index) => {
				if (
					config.platform == "WOO_COMMERCE" &&
					menu.label == "Dispute"
				) {
					return null;
				} else {
					return (
						<MenuLinkMobile
							key={index}
							label={menu.label}
							to={menu.to}
							activeOnlyWhenExact={menu.exact}
						/>
					);
				}
			});
		}
		return result;
	};

	const changeMobileMenu = useCallback(() => {
		setMenuMobileOpen(false);
	}, []);

	const MenuLinkMobile = (props) => {
		const { label, to, activeOnlyWhenExact } = props;
		return (
			<Route
				path={to.pathname}
				exact={activeOnlyWhenExact}
				children={() => {
					return (
						<Link onClick={() => changeMobileMenu()} to={to}>
							{label}
						</Link>
					);
				}}
			/>
		);
	};
	const [popoverActive, setPopoverActive] = useState(false);

	const togglePopoverActive = useCallback(
		() => setPopoverActive((popoverActive) => !popoverActive),
		[]
	);
	const activator = (
		<Button
			icon={QuestionMarkMinor}
			onClick={togglePopoverActive}
			disclosure
		>
			Help Center
		</Button>
	);

	return (
		<div className="topnav-wrap p-3">
			<div className="d-flex active-plan-status">
				<div className="d-flex">
					{/* <div className="d-flex features-request mr-5">
            <img className="ring" src={ring} width={50} />
            <RoterLink
              className="mt-3"
              to={{
                pathname: config.pathName + "/feature-requests",
                search: "?" + config.urlParamsValue,
              }}
            >
              Feature Requests
            </RoterLink>
          </div> */}
					<div className="mt-2">
						{config.platform !== "WOO_COMMERCE" ? (
							<span className="what-new-menu">
								<RoterLink
									to={{
										pathname: config.pathName + "/whatnew",
										search: "?" + config.urlParamsValue,
									}}
								>
									<SvgWhatNew />
								</RoterLink>
							</span>
						) : null}
						<Badge status="success" progress="complete">
							<RoterLink
								style={{ color: "#333" }}
								to={{
									pathname: config.pathName + "/account",
									search: "?" + config.urlParamsValue,
								}}
							>
								Active Plan:{" "}
								<span
									className="ml-2"
									style={{ textTransform: "uppercase" }}
								>
									{dataSettings.plan}
								</span>
							</RoterLink>
						</Badge>
					</div>
				</div>
			</div>
			<div className="desktop-nav">
				<ButtonGroup segmented>
					{showMenu(menu)}

					{config.platform == "WOO_COMMERCE" ? (
						<LinkPolaris
							external
							url="https://woocommerce.com/document/synctrack-tutorial/"
						>
							<Button icon={NoteMinor}>Document</Button>
						</LinkPolaris>
					) : (
						<Popover
							active={popoverActive}
							activator={activator}
							autofocusTarget="first-node"
							onClose={togglePopoverActive}
						>
							<ActionList
								actionRole="menuitem"
								items={[
									{
										content: "Document",
										icon: NoteMinor,
										url: "https://docs.synctrack.io/",
										external: true,
									},
									// {
									//   content: "Tutorial",
									//   icon: PlayMinor,
									//   url:
									//     config.pathName +
									//     "/video-tutorial?" +
									//     config.urlParamsValue,
									// },

									{
										content: "FAQs",
										icon: QuestionMarkMinor,
										onAction: () => setOpenFaqs(!openFaqs),
									},
								]}
							/>
						</Popover>
					)}
				</ButtonGroup>
			</div>
			<div className="mobile-nav">
				<MenuNav left isOpen={menuMobileOpen}>
					{showMenuMobile(menu)}
				</MenuNav>
			</div>
			<HelpCenter
				openFaqs={openFaqs}
				closeSheet={() => setOpenFaqs(false)}
			/>
		</div>
	);
};

export default Menu;
